import { render } from "./PokemonPage.vue?vue&type=template&id=4e4d05d6"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/shicksal/Documentos/Trabajos/Vue-js/vue-udemy/04-pokemon-game/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__